module.exports = __webpack_public_path__ + "assets/bf-landing.43d3c4fa.svg";